document.addEventListener('DOMContentLoaded', function () {
  const kitSelect = document.querySelector('.jump-select select');

  const products = window.productVariants;
  if (kitSelect !== null) {
    kitSelect.addEventListener('change', () => {
      const kitSelectValue = kitSelect.value;

      const foundProduct = products.find((product) => product.title === kitSelectValue);

      const inputs = document.querySelectorAll('.jump-kits');

      if (inputs.length !== 0) {
        inputs.forEach((input) => {
          const normalPriceElem = input.querySelector('.normal-price');
          const multiplier = input.querySelector('.jump-product--kit__input').value;

          if (normalPriceElem !== null) {
            const discount = (Number(input.querySelector('.jump-product--kit__input').dataset.discount) + 100) / 100;

            const discountedPrice = (foundProduct.price / discount / 100) * multiplier;

            const formatedPrice = formatPrice(discountedPrice);

            normalPriceElem.innerHTML = formatedPrice;
          }

          const oldPriceElem = input.querySelector('.old-price');

          if (oldPriceElem !== null) {
            const oldPrice = (foundProduct.price / 100) * multiplier;

            const formatedOldPrice = formatPrice(oldPrice);

            oldPriceElem.innerHTML = formatedOldPrice;
          }
        });
      }
    });
  }
});

function formatPrice(price) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    roundingMode: 'ceil',
    maximumSignificantDigits: Math.trunc(Math.abs(price)).toFixed().length,
  }).format(price);
}
